/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentDraftsControllerApproveMutationRequest, DocumentDraftsControllerApproveMutationResponse, DocumentDraftsControllerApprovePathParams, DocumentDraftsControllerApprove400, DocumentDraftsControllerApprove401, DocumentDraftsControllerApprove403 } from "../../models/documentDraftsController/DocumentDraftsControllerApprove";

function getDocumentDraftsControllerApproveUrl(threadId: DocumentDraftsControllerApprovePathParams["threadId"], version: DocumentDraftsControllerApprovePathParams["version"]) {
  const res = { method: 'POST', url: `/api/v1/document-drafts/${threadId}/versions/${version}/approve` as const }  
  return res
}

/**
 * {@link /api/v1/document-drafts/:threadId/versions/:version/approve}
 */
export async function documentDraftsControllerApprove(threadId: DocumentDraftsControllerApprovePathParams["threadId"], version: DocumentDraftsControllerApprovePathParams["version"], data?: DocumentDraftsControllerApproveMutationRequest, config: Partial<RequestConfig<DocumentDraftsControllerApproveMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DocumentDraftsControllerApproveMutationResponse, ResponseErrorConfig<DocumentDraftsControllerApprove400 | DocumentDraftsControllerApprove401 | DocumentDraftsControllerApprove403>, DocumentDraftsControllerApproveMutationRequest>({ method : "POST", url : getDocumentDraftsControllerApproveUrl(threadId, version).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}